export { default as Terms } from '@src/features/terms/components/Terms';
export { default as TermsModal, DocComponent } from '@src/features/terms/components/TermsModal';
